import Account from "../components/dashboard/account";
import Home from "../components/dashboard/home";
import Profile from "../components/dashboard/profile";
import Table from "../components/dashboard/table";
import {AiFillHome} from 'react-icons/ai';
import {FaUserCircle} from 'react-icons/fa';
import {FaTable} from 'react-icons/fa';
export const siderBar=[
    {
        label:"Dashboard",
        path:"/dashboard/home",
        element:<Home />,
        icon:<AiFillHome className="fill-white" />,
    },
    {
        label:"Profile",
        path:"/dashboard/profile",
        element:<Profile />,
        icon:<FaUserCircle className="fill-white"/>,
       
    },
    {
       label:"Table",
       path:"/dashboard/table",
       element:<Table />,
       icon:<FaTable className="fill-white"/>,
      
    }
]

export const account={path:"/dashboard/account",element:<Account />,label:"account"}